// components/common/Toast.jsx — eine Rückmeldung unten am Rand (18.10.2026)
//
// Statt alert(): blockiert nicht, verschwindet von selbst, steht dort, wo man
// nach dem Speichern hinschaut (unten mittig) — auch wenn man weit unten in
// einem Reiter gespeichert hat.
//
//   import { toast } from '../common/Toast';
//   toast.ok('Gespeichert');
//   toast.fehler('Speichern fehlgeschlagen: …');
//   toast.info('3 Kämpfe erzeugt');
//
// Kein Provider nötig: beim ersten Aufruf hängt sich ein eigener Wurzelknoten
// an <body>. Fehler bleiben länger stehen und werden vorgelesen (role=alert).
//
// Lange Hinweise (mehr als LANG Zeichen oder mit Absatz) bleiben stehen, bis
// man sie schließt: in fünf Sekunden liest niemand eine Liste von
// Kategorien (Zeitplan „Nicht eingeplant …“). Dauer 0 erzwingt das ebenfalls.

import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './Toast.css';

let zaehler = 0;
let hoerer = null;
let wurzel = null;
const warteschlange = [];
const LANG = 140;

function ToastHost() {
  const [liste, setListe] = useState([]);

  useEffect(() => {
    hoerer = (eintrag) => {
      setListe((l) => [...l.slice(-3), eintrag]);
      if (!eintrag.bleibt) setTimeout(() => setListe((l) => l.filter((x) => x.id !== eintrag.id)), eintrag.dauer);
    };
    while (warteschlange.length) hoerer(warteschlange.shift());
    return () => { hoerer = null; };
  }, []);

  if (!liste.length) return null;
  return (
    <div className="tda-toasts">
      {liste.map((e) => (
        <div
          key={e.id}
          className={`tda-toast tda-toast--${e.art}`}
          role={e.art === 'fehler' ? 'alert' : 'status'}
          aria-live={e.art === 'fehler' ? 'assertive' : 'polite'}
          onClick={() => setListe((l) => l.filter((x) => x.id !== e.id))}
          title="Zum Schließen klicken"
        >
          <span className="tda-toast-zeichen" aria-hidden="true">
            {e.art === 'ok' ? '✓' : e.art === 'fehler' ? '!' : 'i'}
          </span>
          <span className="tda-toast-text">{e.text}</span>
          {e.bleibt && (
            <button type="button" className="tda-toast-zu" aria-label="Hinweis schließen"
              onClick={(ev) => { ev.stopPropagation(); setListe((l) => l.filter((x) => x.id !== e.id)); }}>×</button>
          )}
        </div>
      ))}
    </div>
  );
}

function zeigen(art, text, dauer) {
  if (typeof document === 'undefined') return;
  const t = String(text ?? '');
  const eintrag = { id: ++zaehler, art, text: t, dauer, bleibt: dauer === 0 || t.length > LANG || t.includes('\n\n') };
  if (!wurzel) {
    const knoten = document.createElement('div');
    knoten.id = 'tda-toast-wurzel';
    document.body.appendChild(knoten);
    wurzel = createRoot(knoten);
    wurzel.render(<ToastHost />);
  }
  if (hoerer) hoerer(eintrag); else warteschlange.push(eintrag);
}

export const toast = {
  ok:     (text, dauer = 3500) => zeigen('ok', text, dauer),
  info:   (text, dauer = 5000) => zeigen('info', text, dauer),
  fehler: (text, dauer = 8000) => zeigen('fehler', text, dauer),
};

export default toast;
